var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.defaultTab},on:{"select":_vm.onType}},_vm._l((_vm.types),function(item){return (item.isShow)?_c('el-menu-item',{key:item.key,attrs:{"index":item.key}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.name))])]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }